// src/components/AdminPanel.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllUsers, grantPoints, getSeasons } from '../services/api';
import { getPromoCodes, deletePromoCode } from '../services/api';
import PromoCodeManager from './PromoCodeManager';
import CreatePromoCodeForm from './CreatePromoCodeForm';
import CreateSeasonForm from './CreateSeasonForm';
import SeasonManager from './SeasonManager';
import GrantItemForm from './GrantItemForm';
import UserSearchInput from './UserSearchInput';
import BotStatusForm from './BotStatusForm';

const CATEGORIES = ["Ежемесячное", "За достижение", "Прочее"];

export default function AdminPanel({ onPointsGranted }) {
    const [users, setUsers] = useState([]);
    const [seasons, setSeasons] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [points, setPoints] = useState('');
    const [category, setCategory] = useState(CATEGORIES[0]);
    const [customReason, setCustomReason] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [mode, setMode] = useState('grant');
    const [promoCodes, setPromoCodes] = useState([]);

    const navigate = useNavigate();

    const loadAdminData = () => {
        getAllUsers().then(res => setUsers(res.data));
        getSeasons().then(res => setSeasons(res.data));
        getPromoCodes().then(res => setPromoCodes(res.data));
    };

    useEffect(() => {
        loadAdminData();
    }, []);

    const handleDeletePromoCode = async (codeId) => {
        if (window.confirm('Удалить этот промокод?')) {
            await deletePromoCode(codeId);
            loadAdminData(); // Обновляем список
        }
    };

    const activeSeason = seasons.find(s => s.status === 'ACTIVE');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedUser || !points) {
            setMessage('Выберите пользователя и укажите количество очков.');
            return;
        }

        const finalPoints = mode === 'grant' ? parseInt(points, 10) : -parseInt(points, 10);

        setIsLoading(true);
        setMessage('');
        try {
            await grantPoints({
                recipientId: selectedUser,
                points: finalPoints,
                category: category,
                reason: customReason,
            });
            setMessage(`Очки успешно ${mode === 'grant' ? 'начислены' : 'сняты'}!`);
            // Очистка формы
            setSelectedUser('');
            setPoints('');
            setCustomReason('');
            // Вызываем функцию обратного вызова, чтобы дашборд обновил данные
            onPointsGranted();
        } catch (error) {
            setMessage('Ошибка при начислении очков.');
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-panel">
            <h4>Панель администратора</h4>
            <div className="admin-sections">
                {/* Секция начисления очков */}
                <button
                    type="button"
                    className="analytics-nav-btn"
                    onClick={() => navigate('/admin/stats')}
                >
                    📊 Статистика и аналитика сервера →
                </button>
                <div className="points-grant-section">

                    <div className="mode-switcher">
                        <button
                            className={`mode-button ${mode === 'grant' ? 'active' : ''}`}
                            onClick={() => setMode('grant')}
                        >
                            Начислить
                        </button>
                        <button
                            className={`mode-button ${mode === 'deduct' ? 'active' : ''}`}
                            onClick={() => setMode('deduct')}
                        >
                            Снять
                        </button>
                    </div>

                    {!activeSeason ? (
                        <p className="no-season-warning">Нельзя начислить очки, нет активного сезона!</p>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <label>Пользователь:</label>
                            <UserSearchInput users={users} onUserSelect={setSelectedUser} />

                            <label>Очки:</label>
                            <input type="number" value={points} onChange={e => setPoints(e.target.value)} required />

                            <label>Категория:</label>
                            <select value={category} onChange={e => setCategory(e.target.value)}>
                                {CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                            </select>

                            <label>Причина (кастомная):</label>
                            <input type="text" value={customReason} onChange={e => setCustomReason(e.target.value)} placeholder="Например, за отличную идею" />

                            <button
                                type="submit"
                                disabled={isLoading}
                                className={mode === 'deduct' ? 'deduct-button' : ''}
                            >
                                {isLoading ? 'Обработка...' : (mode === 'grant' ? 'Начислить очки' : 'Снять очки')}
                            </button>
                            {message}
                        </form>
                    )}
                </div>
                <div className="grant-item-section">
                    <GrantItemForm users={users} />
                </div>

                <div className="admin-section" style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #40444b' }}>
                    <BotStatusForm />
                </div>


                {/* Секция управления сезонами */}
                <div className="seasons-section">
                    <h5>Управление сезонами</h5>
                    <SeasonManager seasons={seasons} onUpdate={loadAdminData} />
                    <CreateSeasonForm onSeasonCreated={loadAdminData} />
                </div>
                <div className="promocodes-section">
                    <h5>Промокоды</h5>
                    <PromoCodeManager codes={promoCodes} onDelete={handleDeletePromoCode} />
                    <CreatePromoCodeForm onCodeCreated={loadAdminData} />
                </div>
            </div>
        </div>
    );
}